export const OPTION_TAB_VALUE = {
    SMART_MATCHING: 'smartMatching',
    ALL_TUTORS: 'allTutors',
    CLASS: 'class',
    ONETOONE: 'oneToOne',
}